<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap"
        v-model="localVisible"
        :footer="null"
        :maskClosable="false"
        @cancel="cancel"
>
      <div slot="title">查看</div>
      <div id="printDiv" ref="print">
        <a-form-model :model="localForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="名称">
            <a-input disabled v-model="localForm.name" />
          </a-form-model-item>
          <a-form-model-item label="编号">
            <a-input disabled v-model="localForm.number" />
          </a-form-model-item>
          <a-form-model-item label="联系人">
            <a-input disabled v-model="localForm.contact" />
          </a-form-model-item>
          <a-form-model-item label="手机号">
            <a-input disabled v-model="localForm.phone" />
          </a-form-model-item>
          <a-form-model-item label="邮箱">
            <a-input disabled v-model="localForm.email" />
          </a-form-model-item>
          <a-form-model-item label="地址">
            <a-input disabled v-model="localForm.address" />
          </a-form-model-item>
          <a-form-model-item label="上传附件">
            <a-upload
                    disabled
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    list-type="picture"
                    :file-list="localForm.ID_image"
                    @preview="handlePreview"
                    name="file"
>
            </a-upload>
          </a-form-model-item>
          <a-form-model-item label="备注">
            <a-textarea disabled v-model="localForm.remark" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <div style="text-align: center">
        <a-button style="margin: 10px 30px" type="primary" v-print="printOptions" @click="printOrder">打印</a-button>
      </div>
    </a-modal>
    <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
const IMAGE_EXTS = ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.tiff', '.tif', '.webp', '.svg', '.ico', '.raw'];
const OFFICE_EXTS = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
function isImageFile(name) {
  if (!name) return false;
  return IMAGE_EXTS.some(ext => name.toLowerCase().endsWith(ext));
}
function isOfficeFile(name) {
  if (!name) return false;
  return OFFICE_EXTS.some(ext => name.toLowerCase().endsWith(ext));
}
export default {
  name: "FormModal1",
  model: { prop: "visible", event: "cancel" },
  props: ["visible", "form", "clientsClassificationOptions"],
  data() {
    return {
      printOptions: {
        id: "printDiv",
        popTitle: "正常打印",
        extraHead: "",
      },
      previewVisible: false,
      previewImage: '',
      uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
      localVisible: this.visible,
      localForm: {},
    };
  },
  computed: {
    uploadHeaders() {
      const token = Cookies.get('access');
      return token ? { Authorization: 'Bearer ' + token } : {};
    },
  },
  watch: {
    visible(v) {
      this.localVisible = v;
      if (v) {
        this.localForm = JSON.parse(JSON.stringify(this.form.others || {}));
        if (!this.localForm.ID_image) this.$set(this.localForm, 'ID_image', []);
      }
    },
  },
  methods: {
    printOrder() {
      this.$print(this.$refs.print);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      const name = file.name || file.url || '';
      const url = file.url || (file.response && file.response.data && file.response.data.file_url) || '';
      if (!isImageFile(name)) {
        if (!url) return;
        if (isOfficeFile(name)) {
          try {
            const res = await fetch(url);
            const blob = await res.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = name.split('/').pop() || 'file';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
          } catch (e) {
            window.open(url, '_blank');
          }
        } else {
          window.open(url, '_blank');
        }
        return;
      }
      if (!file.url && !file.preview) {
        if (file.originFileObj instanceof Blob) {
          file.preview = await getBase64(file.originFileObj);
        } else if (file.response && file.response.data && file.response.data.file_url) {
          file.preview = file.response.data.file_url;
        } else {
          return;
        }
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    cancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
